import { useEffect, useReducer, useState } from 'react';
import { useAulaEditorContext } from '../../EditorContext';
import { FAILED, LOADING, SUCCESS } from '../../lib/apiStatusTypes';
import { reducer } from '../../lib/fetchReducer';
import { StatusTypes } from '../../lib/loadingStatusTypes';

export const useFetchData = (endpointUrl: string) => {
  const { config } = useAulaEditorContext();
  const { accessToken } = config;
  const [state, dispatch] = useReducer(reducer, {
    status: StatusTypes.IDLE,
    data: [],
  });
  const [retryFlag, setRetryFlag] = useState(false);

  const retry = () => {
    setRetryFlag(!retryFlag);
  };

  useEffect(() => {
    const getDataReq = async ({ signal: abortSignal }: AbortController) => {
      if (state.status === StatusTypes.LOADING) {
        return;
      }
      try {
        dispatch({ type: LOADING });

        const result = await fetch(`${config.apiUrl}/${endpointUrl}`, {
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          signal: abortSignal,
        });

        const request = await result.json();
        if (request?.errors?.length > 0) {
          // eslint-disable-next-line no-console
          console.error(request.errors[0]);
          dispatch({ type: FAILED, payload: request.errors[0] });

          return;
        }
        dispatch({ type: SUCCESS, payload: request });
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        dispatch({ type: FAILED, payload: ex });
      }
    };

    const abortController = new AbortController();
    void getDataReq(abortController);

    return () => abortController.abort();
    // eslint-disable-next-line
  }, [accessToken, config.apiUrl, endpointUrl, retryFlag]);

  return { state, retry };
};
